"use client";

"use client";

import { RefreshCw } from "lucide-react";
import { useTranslations } from "next-intl";

import { Button } from "@/components/ui/button";

/**
 * Layar error — wajib ada sejak Tahap 1 (PRD Frontend Web §6), justru paling
 * dibutuhkan saat sistem sedang tertekan.
 *
 * Pesan untuk manusia, bukan kode error mentah. Detail teknis tidak ditampilkan
 * agar tidak membocorkan informasi internal (PRD Keamanan §5.4).
 */
export default function Error({ reset }: { error: Error; reset: () => void }) {
  const t = useTranslations("ErrorPage");
  return (
    <div className="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center gap-stack-md px-container-margin text-center">
      <div className="grid size-16 place-items-center rounded-full bg-secondary-container/25">
        <RefreshCw className="size-7 text-secondary" aria-hidden />
      </div>
      <h1 className="font-headline text-headline-lg text-on-surface">
        {t("title")}
      </h1>
      <p className="text-body-sm text-on-surface-variant">
        {t("description")}
      </p>
      <Button onClick={reset} size="lg">
        {t("tryAgain")}
      </Button>
      <Button href="/beranda" variant="ghost">
        {t("backToHome")}
      </Button>
    </div>
  );
}
